import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingComponent } from './loading/loading.component';
import { LoaderComponent } from './loader/loader.component';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [LoadingComponent, LoaderComponent, NotFoundComponent],
  imports: [CommonModule, NgxSpinnerModule],
  exports: [LoadingComponent, LoaderComponent, NotFoundComponent],
})
export class ComponentsModule {}
